import { createSelector } from '@ngrx/store';

import { manageSurveyFeature } from './manage-survey.feature';

const { selectManageSurveyState: selectManageSurvey } = manageSurveyFeature;

export const selectSurvey = createSelector(
  selectManageSurvey,
  ({ survey }) => survey,
);

export const selectChildSurvey = createSelector(
  selectManageSurvey,
  ({ childSurvey }) => childSurvey,
);

export const selectChildSurveyLoading = createSelector(
  selectManageSurvey,
  ({ childSurveyLoading }) => childSurveyLoading,
);

export const selectChildSurveyError = createSelector(
  selectManageSurvey,
  ({ childSurveyError }) => childSurveyError,
);

export const selectHealthMetrics = createSelector(
  selectManageSurvey,
  ({ healthMetrics }) => healthMetrics,
);

export const selectHealthMetricsLoading = createSelector(
  selectManageSurvey,
  ({ healthMetricsLoading }) => healthMetricsLoading,
);

export const selectHealthMetricsError = createSelector(
  selectManageSurvey,
  ({ healthMetricsError }) => healthMetricsError,
);

export const selectRemainingHours = createSelector(
  selectManageSurvey,
  ({ remainingHours }) => remainingHours,
);

export const selectRemainingHoursLoading = createSelector(
  selectManageSurvey,
  ({ remainingHoursLoading }) => remainingHoursLoading,
);

export const selectRemainingHoursError = createSelector(
  selectManageSurvey,
  ({ remainingHoursError }) => remainingHoursError,
);

export const selectActivityLogs = createSelector(
  selectManageSurvey,
  ({ activityLogs }) => activityLogs,
);

export const selectActivityLogsLoading = createSelector(
  selectManageSurvey,
  ({ activityLogsLoading }) => activityLogsLoading,
);

export const selectActivityLogsError = createSelector(
  selectManageSurvey,
  ({ activityLogsError }) => activityLogsError,
);

export const selectComments = createSelector(
  selectManageSurvey,
  ({ comments }) => comments,
);

export const selectCommentsLoading = createSelector(
  selectManageSurvey,
  ({ commentsLoading }) => commentsLoading,
);

export const selectCommentsError = createSelector(
  selectManageSurvey,
  ({ commentsError }) => commentsError,
);

export const selectAddingComment = createSelector(
  selectManageSurvey,
  ({ addingComment }) => addingComment,
);

export const selectAddCommentError = createSelector(
  selectManageSurvey,
  ({ addCommentError }) => addCommentError,
);

export const selectManageSurveyLoading = createSelector(
  selectManageSurvey,
  ({ loading }) => loading,
);

export const selectManageSurveyError = createSelector(
  selectManageSurvey,
  ({ error }) => error,
);

export const selectQuotas = createSelector(
  selectManageSurvey,
  ({ quotas }) => quotas,
);

export const selectQuotasLoading = createSelector(
  selectManageSurvey,
  ({ quotasLoading }) => quotasLoading,
);

export const selectQuotaTotal = createSelector(
  selectManageSurvey,
  ({ quotaTotal }) => quotaTotal,
);

export const selectQuotaSearch = createSelector(
  selectManageSurvey,
  ({ quotaSearch }) => quotaSearch,
);

export const selectQuotaLoadedPage = createSelector(
  selectManageSurvey,
  ({ quotaLoadedPage }) => quotaLoadedPage,
);

export const selectQuotasLoadingMore = createSelector(
  selectManageSurvey,
  ({ quotasLoadingMore }) => quotasLoadingMore,
);

export const selectQuotaLockingIds = createSelector(
  selectManageSurvey,
  ({ quotaLockingIds }) => quotaLockingIds,
);

export const selectQuotaSavingIds = createSelector(
  selectManageSurvey,
  ({ quotaSavingIds }) => quotaSavingIds,
);

export const selectQuotaCurrentlyOpenSavingIds = createSelector(
  selectManageSurvey,
  ({ quotaCurrentlyOpenSavingIds }) => quotaCurrentlyOpenSavingIds,
);

export const selectSupplierQuotaSavingIds = createSelector(
  selectManageSurvey,
  ({ supplierQuotaSavingIds }) => supplierQuotaSavingIds,
);

export const selectSupplierQuotaCurrentlyOpenSavingIds = createSelector(
  selectManageSurvey,
  ({ supplierQuotaCurrentlyOpenSavingIds }) =>
    supplierQuotaCurrentlyOpenSavingIds,
);

export const selectQuotaRenamingIds = createSelector(
  selectManageSurvey,
  ({ quotaRenamingIds }) => quotaRenamingIds,
);

export const selectQuotaCpiSavingIds = createSelector(
  selectManageSurvey,
  ({ quotaCpiSavingIds }) => quotaCpiSavingIds,
);

export const selectTrafficChannels = createSelector(
  selectManageSurvey,
  ({ trafficChannels }) => trafficChannels,
);

export const selectTrafficChannelsLoading = createSelector(
  selectManageSurvey,
  ({ trafficChannelsLoading }) => trafficChannelsLoading,
);

export const selectTrafficChannelsError = createSelector(
  selectManageSurvey,
  ({ trafficChannelsError }) => trafficChannelsError,
);

export const selectTcStatusChangingIds = createSelector(
  selectManageSurvey,
  ({ tcStatusChangingIds }) => tcStatusChangingIds,
);

export const selectCreatingTrafficChannel = createSelector(
  selectManageSurvey,
  ({ creatingTrafficChannel }) => creatingTrafficChannel,
);

export const selectTrafficChannelCreationError = createSelector(
  selectManageSurvey,
  ({ trafficChannelCreationError }) => trafficChannelCreationError,
);

export const selectPsidUploadLoading = createSelector(
  selectManageSurvey,
  ({ psidUploadLoading }) => psidUploadLoading,
);

export const selectPsidUploadError = createSelector(
  selectManageSurvey,
  ({ psidUploadError }) => psidUploadError,
);

export const selectPsidUploadFilePath = createSelector(
  selectManageSurvey,
  ({ psidUploadFilePath }) => psidUploadFilePath,
);

export const selectPsidUploadUniqCount = createSelector(
  selectManageSurvey,
  ({ psidUploadUniqCount }) => psidUploadUniqCount,
);

export const selectPsidUploadTotalCount = createSelector(
  selectManageSurvey,
  ({ psidUploadTotalCount }) => psidUploadTotalCount,
);

export const selectCrmIdSaving = createSelector(
  selectManageSurvey,
  ({ crmIdSaving }) => crmIdSaving,
);

export const selectCrmIdError = createSelector(
  selectManageSurvey,
  ({ crmIdError }) => crmIdError,
);

export const selectAsanaIdSaving = createSelector(
  selectManageSurvey,
  ({ asanaIdSaving }) => asanaIdSaving,
);

export const selectAsanaIdError = createSelector(
  selectManageSurvey,
  ({ asanaIdError }) => asanaIdError,
);

export const selectBillingNumberSaving = createSelector(
  selectManageSurvey,
  ({ billingNumberSaving }) => billingNumberSaving,
);

export const selectBillingNumberError = createSelector(
  selectManageSurvey,
  ({ billingNumberError }) => billingNumberError,
);

export const selectCustomRedirectFieldSaving = createSelector(
  selectManageSurvey,
  ({ customRedirectFieldSaving }) => customRedirectFieldSaving,
);

export const selectCustomRedirectFieldError = createSelector(
  selectManageSurvey,
  ({ customRedirectFieldError }) => customRedirectFieldError,
);
